import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Component } from 'react';
import Raven from 'raven-js';
import ErrorMessage from 'framework-asset-preview-lib/internal/shared/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
    this.componentDidCatch = (error, errorInfo) => {
      Raven.captureException(error, {
        extra: {
          errorInfo,
          componentStack: errorInfo.componentStack,
          error
        },
        fingerprint: [this.props.fingerprint],
        tags: {
          lib: 'framework-asset-preview-lib'
        }
      });
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  render() {
    const {
      hasError
    } = this.state;
    if (!hasError) {
      return this.props.children;
    }
    if (this.props.errorComponent) {
      return this.props.errorComponent;
    }
    return /*#__PURE__*/_jsx(ErrorMessage, {
      applicationId: this.props.applicationId,
      errorType: "ERROR_BOUNDARY"
    });
  }
}
export default ErrorBoundary;

/**
 * This helper allows errors thrown in the body of a render prop to be caught by an error boundary
 * For example, if you do `<ErrorBoundary>{renderProp()}</ErrorBoundary>` and `renderProp` throws, the error boundary
 * won't catch it because it throws in the parent, before ErrorBoundary is mounted/rendered
 *
 * Instead, by using `<WithErrorBoundary>{() => renderProp()}</WithErrorBoundary>`
 * `renderProp` won't be called until ErrorBoundary is ready to catch its errors
 */
const WithErrorBoundaryInner = ({
  render
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: render()
});
export function WithErrorBoundary(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(WithErrorBoundaryInner, {
      render: children
    })
  }));
}